module.exports = __webpack_public_path__ + "static/media/editor_screenshot_en.d38c4e97.png";